import { HttpClient } from '@angular/common/http';
import { Injectable, signal } from '@angular/core';
import { map, Observable, tap } from 'rxjs';
import { API, environment } from '@core/envs';
import { SessionService } from '@agenda-customer-ui/data-access';
import { StorageKeys } from '@core/enums';
import { Quotation, RevisionHistory, RevisionModel, ScheduleHistory } from 'libs/core/src/interfaces/from-history/models';
import { IResponseModel } from '@core/interface';

const URL = environment.getRoute(API.transformation);

@Injectable({
  providedIn: 'root'
})
export class HistoryService {
  private cache = new Map<string, any>();
  listHistory = signal<RevisionHistory[]>([]);

  constructor(
    private http: HttpClient,
    private sessionService: SessionService
  ) { }

  getRevisionHistory(vin: string, country: string): Observable<RevisionHistory[]> {
    // TODO: usar MAP ou storage? para armazenar os dados em cache
    const historyData = this.sessionService.getObject<RevisionHistory[]>(StorageKeys.REVISION_HISTORY);

    if (historyData.length && vin === historyData[0].vin) {
      return new Observable(data => data.next(historyData));
    }

    const revisionUrl = `${URL}/revisions/v2/history?country=${country}`;
    return this.http.post<IResponseModel<RevisionHistory[]>>(revisionUrl, { vin }).pipe(
      map(data => {
        this.listHistory.set(data.response);
        this.sessionService.setObject(StorageKeys.REVISION_HISTORY, data.response);
        return data.response;
      })
    );
  }

  getScheduleHistory(vin: string, country: string): Observable<IResponseModel<ScheduleHistory[]>> {
    // TODO: usar MAP ou storage? para armazenar os dados em cache
    const historyData = this.sessionService.getObject(StorageKeys.SCHEDULE_HISTORY) as IResponseModel<ScheduleHistory[]>;

    if (historyData.response?.length && vin === historyData.response[0].vin) {
      return new Observable(data => data.next(historyData));
    }

    const scheduleUrl = `${URL}/schedules/v2/history`;
    return this.http.post<IResponseModel<ScheduleHistory[]>>(scheduleUrl, { vin }, { params: { country } }).pipe(
      map(data => {
        this.sessionService.setObject(StorageKeys.SCHEDULE_HISTORY, data);
        return data;
      })
    );
  }

  getScheduleQuotation(advisorId: number, scheduleDate: string, scheduleHour: number, dealerId: number, country: string): Observable<IResponseModel<Quotation>> {
    const url = `${URL}/quotations?advisor=${advisorId}&country=${country}&date=${scheduleDate}&dealer=${dealerId}&hour=${scheduleHour}`;
    return this.http.get<IResponseModel<Quotation>>(url);
  }

  getRevision(month: number, vin: string, country: string): Observable<IResponseModel<RevisionModel[]>> {
    const keyCache = `${StorageKeys.REVISIONS_PARTS}_${vin}_${country}_${month}`;
    if (this.cache.has(keyCache)) {
      console.log(this.cache.get(keyCache))
      return new Observable(data => data.next(this.cache.get(keyCache)));
    } else {
      const url = `${URL}/revisions/v2`;
      return this.http.post<IResponseModel<RevisionModel[]>>(url, { vin }, { params: { country, month } }).pipe(
        tap(data => this.cache.set(keyCache, data)),
      );
    }
  }

}
